import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#3D98FC',
    },
    mode: 'light',
  },
  typography: {
    fontFamily: 'Montserrat',
  },
});
